import React, { Component } from 'react';
import { toast } from "react-toastify";
import { Button, Form } from 'react-bootstrap';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import axios from '../../../axios';
import apiError from '../../../error';
import Spinner from '../../../component/spinner/spinner';

export default class AiConversation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            welcomePrompt: '',
            systemPrompt: '',
        }
    }

    componentDidMount = () => {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.aiVishingPromptId !== this.props.aiVishingPromptId ||
            prevProps.aiWhatsappPromptId !== this.props.aiWhatsappPromptId ||
            prevProps.promptType !== this.props.promptType) {
            this.load();
        }
    }

    getPromptConfig = () => {
        const isWhatsapp = this.props.promptType === 'whatsapp' || this.props.attackType === 'WhatsApp';
        return {
            isWhatsapp,
            showWelcomePrompt: !isWhatsapp,
            baseUrl: isWhatsapp ? '/api/ai-whatsapp' : '/api/ai-vishing',
            promptId: isWhatsapp ? this.props.aiWhatsappPromptId : this.props.aiVishingPromptId,
            responseKey: isWhatsapp ? 'aiWhatsappPrompt' : 'aiVishingPrompt',
            requestIdKey: isWhatsapp ? 'aiWhatsappPromptId' : 'aiVishingPromptId',
            onPromptId: isWhatsapp ? this.props.handleAiWhatsappPromptId : this.props.handleAiVishingPromptId,
            title: isWhatsapp ? 'AI WhatsApp Conversation' : 'AI Conversation',
            desc: isWhatsapp ? 'Create the AI WhatsApp system prompt' : 'Create AI conversation prompts'
        };
    }

    load = async () => {
        try {
            const config = this.getPromptConfig();
            if(!config.promptId){
                this.setState({
                    welcomePrompt: '',
                    systemPrompt: '',
                });
                return;
            }
            const res = await axios.get(config.baseUrl + '/prompt/' + config.promptId, {});
            const prompt = res.data[config.responseKey] || {};
            this.setState({
                welcomePrompt: config.showWelcomePrompt ? (prompt.welcomePrompt || '') : '',
                systemPrompt: prompt.systemPrompt || '',
            });
        } catch (error) {
            apiError(error);
        }
    }

    validateAiVishingPrompt = () => {
        const config = this.getPromptConfig();
        let data = {};
        let sp = this.state.systemPrompt?.trim();

        if(config.showWelcomePrompt){
            let wp = this.state.welcomePrompt?.trim();
            if(!wp){
                toast.error("Please enter the welcome prompt");
                return;
            }
            data.welcomePrompt = wp;
        }

        if(!sp){
            toast.error("Please enter the system prompt");
            return;
        }
        data.systemPrompt = sp;

        return data;
    }

    handleCreateAiVishingPrompt = async () => {
        try {
            const validateData = this.validateAiVishingPrompt();
            if (!validateData) return;

            this.setState({ loading: true });
            let res;
            const config = this.getPromptConfig();

            if (config.promptId) {
                validateData[config.requestIdKey] = config.promptId;
                res = await axios.patch(config.baseUrl + '/update-prompt', validateData);
            } else {
                validateData.campaignTemplateId = this.props.campaignTemplateId;
                res = await axios.post(config.baseUrl + '/create-prompt', validateData);
                if (config.onPromptId) {
                    // For vishing, backend also returns vishingVoiceSelectionId alongside aiVishingPromptId
                    config.onPromptId(
                        res.data[config.requestIdKey],
                        !config.isWhatsapp ? res.data.vishingVoiceSelectionId : undefined
                    );
                }
                toast.success(res.data.message);
            }

            this.setState({ loading: false });
            this.props.handleTabChange('next');
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }


    render() {
        const config = this.getPromptConfig();
        return (
            <>
                <div className="tabContent-block email-template-wrap">
                    <div className='rightSectionHeader'>
                            <div className="row justify-content-between d-flex align-items-center">
                                <div className="col-md-6 tab-right-header">
                                    <h6>{config.title}</h6>
                                    <p>{config.desc}</p>
                                </div>
                                <div className="col-md-3">
                                    {/* <Form.Group className='sms-input mb-md-0' controlId="aiVishingDeepfakeEnabled">
                                        <Form.Check
                                            type="switch"
                                            id="ai-vishing-deepfake-switch"
                                            label="Enable Deepfake"
                                            checked={this.state.isDeepfakeEnabled}
                                            onChange={e => this.handleDeepfakeToggle(e.target.checked)}
                                        />
                                    </Form.Group> */}
                                </div>
                            </div>
                        </div>
                        {/* {config.showDeepfakeControls && this.state.isDeepfakeEnabled ? (
                        <div className="attackCard">
                            <div className='midCard'>
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <Form.Group className='sms-input mb-0' controlId="aiVishingVoiceId">
                                            <Form.Label>Select Voice</Form.Label>
                                            <Form.Control
                                                as="select"
                                                disabled={!this.state.isDeepfakeEnabled || this.state.loadingVoices}
                                                value={this.state.voiceId}
                                                onChange={e => this.setState({ voiceId: e.target.value })}
                                            >
                                                <option value="">
                                                    {this.state.loadingVoices ? 'Loading voices...' : (this.state.voices.length ? 'Select a voice' : 'No voices available')}
                                                </option>
                                                {this.state.voices.map(voice => (
                                                    <option key={voice.voiceId} value={voice.voiceId}>{voice.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null} */}
                    {config.showWelcomePrompt ? (
                        <div className="attackCard">
                            <div className='midCard'>
                                <div className="row">
                                    <div className="col-md-12">
                                        <Form.Group className='sms-input' controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Welcome Prompt</Form.Label>
                                            <Form.Control size='medium' as="textarea" multiline={true} rows={5} value={this.state.welcomePrompt} onChange={e => this.setState({ welcomePrompt: e.target.value })} />
                                        </Form.Group>             
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <div className="attackCard">
                        <div className='midCard'>
                            <div className="row">
                                <div className="col-md-12">
                                        <Form.Group className='sms-input' controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>System Prompt</Form.Label>
                                            <Form.Control size='medium' as="textarea" multiline={true} rows={config.showWelcomePrompt ? 20 : 20} value={this.state.systemPrompt} onChange={e => this.setState({ systemPrompt: e.target.value })} />
                                        </Form.Group>        
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex'>
                        <Button variant="secondary" className="btn closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleCreateAiVishingPrompt}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
            </>
        )
    }
}
